import { isYearlySubscription } from "@/utils/subscriptionLevels/isYearlySubscription";

export const getConversionTimeResetDate = (
  stripeSubscriptionId: string,
  stripeSubscriptionEndTimestamp: Date
): Date => {
  if (isYearlySubscription(stripeSubscriptionId)) {
    const now = new Date();

    let resetYear = now.getFullYear();
    let resetMonth = now.getMonth();
    let resetDay = stripeSubscriptionEndTimestamp.getDate();

    // Check if the reset day is greater than the number of days in the current month
    const daysInCurrentMonth = new Date(resetYear, resetMonth + 1, 0).getDate();
    if (resetDay > daysInCurrentMonth) {
      resetDay = daysInCurrentMonth;
    }

    // Create a potential reset date
    const potentialResetDate = new Date(resetYear, resetMonth, resetDay);

    // Check if the reset date is before today, not considering the time To ignore the time, we compare only the year, month, and day
    if (
      now.getFullYear() > potentialResetDate.getFullYear() ||
      now.getMonth() > potentialResetDate.getMonth() ||
      (now.getMonth() === potentialResetDate.getMonth() &&
        now.getDate() > potentialResetDate.getDate())
    ) {
      resetMonth++;
      // Adjust the year if the month is December (11 in 0-indexed JavaScript Date)
      if (resetMonth > 11) {
        resetMonth = 0;
        resetYear++;
      }

      // Recheck the number of days in the new month
      const daysInNextMonth = new Date(resetYear, resetMonth + 1, 0).getDate();
      if (resetDay > daysInNextMonth) {
        resetDay = daysInNextMonth;
      }
    }

    return new Date(resetYear, resetMonth, resetDay, 12, 0, 0, 0);
  } else {
    return stripeSubscriptionEndTimestamp;
  }
};
